module.exports = "http://cdn.realive.com.ua/src/views/player/help/images/arena1.jpg";